
<template>
    <div>
        <div class="col-lg-8" v-if="records && records.length > 0">
            <small class="font-weight-bold">
                Showing {{ pagination.from == 0 ? 1 : pagination.from }} - {{ pagination.to }} of
                {{ pagination.total }} entries
            </small>
        </div>

        <div
            class="card shadow"
            v-if="records && records.length > 0"
        >
            <div class="table-responsive">
                <base-table
                    class="table align-items-center table-flush"
                    thead-classes="thead-light"
                    tbody-classes="list"
                    :data="records"
                >
                    <template slot="columns">
                        <th width="2%">S/N</th>
                        <th>School's Name /<br> Application Type</th>
                        <th>RRR / Amount</th>
                        <th>Request Type</th>
                        <th>Remark(s) / <br>Status</th>
                        <th>Date / Time <br>Paid</th>
                    </template>

                    <template
                        slot-scope="{row, index}"
                    >
                        <td class="budget">
                            {{ pagination.from+index}}
                        </td>
                        <td class="text-capitalize">
                            <span v-html="getName(row)"></span><br>
                            <badge type="primary">{{ getAppType(row) }}</badge> &nbsp;
                            <badge type="info">{{ getInstitutionType(row) }}</badge>
                        </td>
                        <td>
                            {{ row.payment_ref }}<br>
                            <badge type="primary">
                                &#x20a6; {{ row.amount | formatPrice }}
                            </badge>
                        </td>
                        <td class="text-capitalize">
                            {{ getType(row) }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.school_application ? row.school_application.status : 'Pending' }}
                        </td>
                        <td>
                            {{ getExactDate(row) | formatDate }}<br>
                            <badge type="success">
                                {{ getExactDate(row) | formatTime }}
                            </badge>
                        </td>
                    </template>
                </base-table>
            </div>

            <div
                class="card-footer d-flex justify-content-end bg-transparent"
                v-if="hasPagination"
                    @click="paginate"
            >
                <base-pagination
                    :total="pagination.total"
                    align="center"
                    v-model="pagination.number"
                    :perPage="pagination.perPage"

                >
                </base-pagination>
            </div>

            <div class="col-lg-12" v-if="totalAmount">
                <hr>
                <div class="container">
                    <h3 class="text-uppercase">
                        total amount paid:
                        <span class="right">
                            &#x20a6; {{ totalAmount | formatPrice }}
                        </span>
                    </h3>

                    <h3 class="text-uppercase">
                        Total Number of Training Schools Accredited:
                        <span class="right">
                            {{ accreditedCount }}
                        </span>
                    </h3>

                    <h3 class="text-uppercase">
                        Total Number of Training Schools Awaiting Accreditation:
                        <span class="right">
                            {{ waitingCount }}
                        </span>
                    </h3>
                </div>
                <hr>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    import Badge from '../../../components/Badge.vue';

    export default {
    components: { Badge },
        name: 'ReportingData',
        props: ['records', 'hasPagination', 'pagination', 'paginate', 'privileges', 'totalAmount', 'accreditedCount',
            'waitingCount'],
        filters: {
            formatDate(date) {
                return date ? moment(date).format('Do MMM, YYYY') : 'N/A';
            },
            formatTime(date) {
                return date ? moment(date).format('hh:mm') : 'N/A';
            },
            formatPrice(value) {
                if(value) {
                    let val = (value/1).toFixed(2).replace(',', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    return 'N/A';
                }
            }
        },
        methods: {
            getName(record) {// get full name
                return record && record.school_application && record.school_application.training_school ?
                    this.breakWord(record.school_application.training_school.name) : 'N/A';
            },
            getInstitutionType(record) {
                return record && record.school_application && record.school_application.training_school ?
                        record.school_application.training_school.type+' Institution' : 'N/A';
            },
            getExactDate(record) {
                return record.date_paid ? record.date_paid : record.date_generated;
            },
            getAppType(record) {// get purpose
                return record.school_application && record.school_application.type ?
                        record.school_application.type : 'N/A';
            },
            getType(record) {// get purpose
                return record.school_application && record.school_application.request_type ?
                        this.replaceAll(record.school_application.request_type, '-', ' ') : 'N/A';
            },
            replaceAll(str, find, replace) {
                return str.replace(new RegExp(find, 'g'), replace);
            },
            breakWord(word, length = 40) {// break word into two parts
                if(word) {
                    let textLength = word.length;
                    let exploded = word.split(' ');
                    if(word && textLength < length) {
                        return word;
                    } else if(word) {
                        let formedWord = '';
                        let half = (exploded.length > 2) ? Math.ceil((exploded.length - 1)/2) : 0;
                        for(let phrase of exploded) {
                            formedWord += phrase+' ';
                            if(exploded[half] == phrase) {
                                formedWord += ' <br> ';
                            }
                        }
                        return formedWord;
                    }
                }
                return 'N/A';
            }
        }
    };
</script>
<style>
    .table td {
        font-size: 15px;
    }
    .right {
        float: right !important;
    }
</style>
